import { useActionParam } from '@api/actions/action';
import { useCallback, useEffect, useState } from '@wordpress/element';
import { POST_ID } from '../../routes/Variables';

export const useMetadadosObter = ({ idPost = POST_ID, executarAutomaticamente = true }) => {
  const [resultado, setResultado] = useState({
    metadados: null,
    carregando: false,
    erro: null,
  });

  const { mutateAsync } = useActionParam();

  const obterMetadados = useCallback(async () => {
    if (!idPost) return;
    setResultado(prev => ({ ...prev, carregando: true, erro: null }));

    await mutateAsync({
      action: 'buscar_meta_dados',
      param: {
        post_id: parseInt(idPost),
      },
    })
      .then(res => {
        setResultado({ metadados: res?.data ?? [], carregando: false, erro: null });
      })
      .catch(erro => {
        setResultado(prev => ({ ...prev, carregando: false, erro }));
      });
  }, [mutateAsync]);

  useEffect(() => {
    if (!executarAutomaticamente || !idPost) return;
    obterMetadados();
  }, [executarAutomaticamente]);

  return { obterMetadados, ...resultado };
};
